<div class="popover" [nbSpinner]="loading()">
  <nb-icon icon="home-outline" pack="eva"></nb-icon>
  <div class="description">
    <div class="title">{{building()?.baseData?.sectionText}}</div>
    <div class="subtitle">{{building()?.internalNumber}} / {{building()?.allocationData?.ownerTenant?.name}} / {{building()?.baseData?.area | number: '1.2-2'}} m²</div>
    <div class="subtitle" *ngIf="building()?.allocationData?.team?.region; else noRegion">Bereich: <span [ngStyle]="{color: building()?.allocationData?.team?.region?.color}">{{building()?.allocationData?.team?.region?.name}}</span></div>
    <div class="subtitle" *ngIf="building()?.allocationData?.team; else noTeam">Team: <span [ngStyle]="{color: building()?.allocationData?.team?.color}">{{building()?.allocationData?.team?.name}}</span></div>
  </div>
  <button nbButton size="small" (click)="navigateToDetail()" *ngIf="!disableLink">
    <nb-icon icon="external-link" pack="eva"></nb-icon>
  </button>
</div>
<ng-template #noRegion>
  <div class="subtitle">kein Bereich</div>
</ng-template>
<ng-template #noTeam>
  <div class="subtitle">kein Team</div>
</ng-template>

